import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlPropertydemat } from "../BaseUrl/baseurl";
import http from "../BaseUrl/baseurl";
import axios from "axios";

const token = localStorage.getItem("token");

export const getInvestorPennyTransaction = createAsyncThunk(
    "getInvestorPennyTransaction",

    // https://propertydemat.com/api/penny/getalluserpennytransacation/?stardDate=${startDate}&=${endDate}
    // https://propertydemat.com/api/penny/getalluserpennytransacation/?stardDate=2024-11-23T09:47:55.747Z&=2025-01-23T09:47:55.747Z

    async ({ startDate, endDate }) => {
        let response;
        try {
            response = await axios.get(
                `${baseUrlPropertydemat}/penny/getalluserpennytransacation/?startDate=${startDate}&endDate=${endDate}`
            );
        } catch (error) {
            console.log("getPropertyList", error);
            return [];
        }
        console.log("I am response from property list", response.data.data);
        return response.data.data;
    }
);

export const getInvestorPoolTransaction = createAsyncThunk(
    "getInvestorPoolTransaction",

    async filterData => {
        let response;
        try {
            response = await axios.get(
                `${baseUrlPropertydemat}/invest/getallinvestdata?status=${filterData}`
            );
        } catch (error) {
            console.log("getInvestorPoolTransaction", error);
            return [];
        }
        console.log("InvestorPool Transaction", response.data.data);
        return response.data.data;
    }
);

export const getPoolTradingTransaction = createAsyncThunk(
    "getPoolTradingTransaction",

    async () => {
        let response;
        try {
            response = await axios.get(
                `${baseUrlPropertydemat}/buylots/getadminsidedata`
            );
        } catch (error) {
            console.log("getPoolTradingTransaction", error);
            return [];
        }
        console.log("getPoolTrading Transaction", response.data.data);
        return response.data.data;
    }
);

export const getAllRefundRequest = createAsyncThunk(
    "getAllRefundRequest",

    async () => {
        let response;
        try {
            response = await axios.get(
                `${baseUrlPropertydemat}/invest/getAllRefundRequest`
            );
        } catch (error) {
            console.log("getInvestorPoolTransaction", error);
        }
        console.log("InvestorPool Transaction", response.data.data);
        return response.data.data;
    }
);

const InvestorPaymentSlice = createSlice({
    name: "Investor Payment",

    initialState: {
        PennyTransaction: [],
        allPoolTransaction: [],
        AllRefundRequest: [],
        PoolTradingTransaction: []
    },

    extraReducers(builder) {
        builder
            .addCase(getInvestorPennyTransaction.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getInvestorPennyTransaction.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.PennyTransaction = action.payload;
            })
            .addCase(getInvestorPennyTransaction.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });

        builder
            .addCase(getInvestorPoolTransaction.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getInvestorPoolTransaction.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.allPoolTransaction = action.payload;
            })
            .addCase(getInvestorPoolTransaction.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });

        builder
            .addCase(getPoolTradingTransaction.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getPoolTradingTransaction.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.PoolTradingTransaction = action.payload;
            })
            .addCase(getPoolTradingTransaction.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });

        builder
            .addCase(getAllRefundRequest.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getAllRefundRequest.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.AllRefundRequest = action.payload;
            })
            .addCase(getAllRefundRequest.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    }
});

export default InvestorPaymentSlice.reducer;
